import { Breadcrumbs, Link, Typography } from "@mui/material";
import "./breadcrumb.css";
import { useEffect, useState } from "react";
import { usePortalProvider } from "../../providers/portal-provider";
import { getCategoryName } from "../../util/get-category-name";
import { getSlugFromPath } from "../../util/get-slug-from-path";
import { useLocation } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/ssr";

function filter_value(value?: breadCrumbValue): boolean {
  return value === undefined
    ? false
    : value.name === undefined && value.link === undefined
    ? false
    : true;
}

export type breadCrumbValue = {
  name?: string;
  link?: string;
};

export const BreadCrumbGeneric = (): JSX.Element => {
  const { pathname } = useLocation();
  const { backend, noHeader, accessToken } = usePortalProvider();
  const { keycloak } = useKeycloak();

  const [crumbs, setCrumbs] = useState<undefined | breadCrumbValue[]>(
    undefined
  );

  useEffect(() => {
    const getAppInfo = async () => {
      const appSlug = getSlugFromPath(pathname, APP_BASE_PATH);

      if (!appSlug) return;

      const effectiveToken = keycloak?.token || accessToken;
      if (effectiveToken) {
        backend?.setAccessToken(effectiveToken);
      }
      const app = await backend?.request(`/v1/app/${appSlug}`);

      const crumbInfo = getCategoryName(app);
      setCrumbs(crumbInfo);
    };

    getAppInfo();
  }, []);

  const firstCrumb = (
    <Link underline="none" color="inherit" href="/">
      Início
    </Link>
  );

  if (crumbs === undefined || noHeader) {
    return <></>;
  }

  return (
    <div className={"breadcrumb-content"}>
      <div className="xvia-container breadcrumb-info_container">
        <h2>
          <Breadcrumbs aria-label="breadcrumb" className="breadcrumb">
            {firstCrumb}
            {crumbs!.map((value, index) => {
              if (filter_value(value)) {
                return index === crumbs!.length - 1 ? (
                  <Typography className="breadcrumb">{value.name}</Typography>
                ) : (
                  <Link underline="none" color="inherit" href={value.link}>
                    {value.name}
                  </Link>
                );
              }

              return null;
            })}
          </Breadcrumbs>
        </h2>
      </div>
    </div>
  );
};
